import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

dayjs.extend(quarterOfYear);

export const date_format = 'YYYY-MM-DD HH:mm:ss';

export const time_range_list: any = (timezone: string = 'UTC') => ({
	all_time: {
		id: 'all_time',
		label: 'All time',
		from: null,
		to: null,
	},
	today: {
		id: 'today',
		label: 'Today',
		from: dayjs().tz(timezone).startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('day').format(date_format),
		compare_key: 'previous_day',
	},
	yesterday: {
		id: 'yesterday',
		label: 'Yesterday',
		from: dayjs().tz(timezone).subtract(1, 'day').startOf('day').format(date_format),
		to: dayjs().tz(timezone).subtract(1, 'day').endOf('day').format(date_format),
		compare_key: 'previous_day',
	},
	this_week: {
		id: 'this_week',
		label: 'This week',
		from: dayjs().tz(timezone).subtract(1, 'day').startOf('week').add(1, 'day').startOf('day').format(date_format),
		to: dayjs().tz(timezone).subtract(1, 'day').endOf('week').add(1, 'day').endOf('day').format(date_format),
		compare_key: 'previous_week',
	},
	last_week: {
		id: 'last_week',
		label: 'Last week',
		from: dayjs().tz(timezone).subtract(1, 'day').subtract(1, 'week').startOf('week').add(1, 'day').startOf('day').format(date_format),
		to: dayjs().tz(timezone).subtract(1, 'day').subtract(1, 'week').endOf('week').add(1, 'day').endOf('day').format(date_format),
		compare_key: 'previous_week',
	},
	this_month: {
		id: 'this_month',
		label: 'This month',
		from: dayjs().tz(timezone).startOf('month').startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('month').endOf('day').format(date_format),
		compare_key: 'previous_month',
	},
	last_month: {
		id: 'last_month',
		label: 'Last month',
		from: dayjs().tz(timezone).subtract(1, 'month').startOf('month').startOf('day').format(date_format),
		to: dayjs().tz(timezone).subtract(1, 'month').endOf('month').endOf('day').format(date_format),
		compare_key: 'previous_month',
	},
	this_quarter: {
		id: 'this_quarter',
		label: 'This quarter',
		from: dayjs().tz(timezone).startOf('quarter').startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('quarter').endOf('day').format(date_format),
		compare_key: 'previous_quarter',
	},
	last_quarter: {
		id: 'last_quarter',
		label: 'Last quarter',
		from: dayjs().tz(timezone).startOf('quarter').subtract(1, 'quarter').startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('quarter').subtract(1, 'quarter').endOf('day').format(date_format),
		compare_key: 'previous_quarter',
	},
	this_year: {
		id: 'this_year',
		label: 'This year',
		from: dayjs().tz(timezone).startOf('year').startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('year').endOf('day').format(date_format),
		compare_key: 'previous_year',
	},
	last_year: {
		id: 'last_year',
		label: 'Last year',
		from: dayjs().tz(timezone).startOf('year').subtract(1, 'year').startOf('day').format(date_format),
		to: dayjs().tz(timezone).endOf('year').subtract(1, 'year').endOf('day').format(date_format),
		compare_key: 'previous_year',
	},
	custom: {
		id: 'custom',
		label: 'Select custom',
		compare_key: 'previous_period',
	},
});

export const default_time_range_id = 'all_time';

export const ALL_TIME_ID = 'all_time';
